import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecambistasMessages } from '../../../../../../redux/features/dashboard';
import Loading from '../../../shared/components/Loading';
import '../Dashboard.scss';
import MessagesList from './components/MessagesList';

export default function UserDashboard() {
  const dispatch = useDispatch();
  const dashboard = useSelector(state => state.dashboard.user );

  useEffect(() => {
    dispatch(fetchRecambistasMessages());
  }, []);

  return (
    <div className='w-100 d-flex flex-column dashboard pb-5'>
        <div className='w-100 d-flex flex-column align-items-start summary mb-4'>
          <MessagesList mensajes={dashboard?.mensajes} />
        </div>
    </div>
  )
}
